<template>
  <div class="text-center mt-10">
    <div class="display-1 font-weight-light mb-10">
      {{ $t("messages.information.left_meeting") }}
    </div>
    <div class="text-center">
      <v-btn
        outlined
        @click="$emit('goToReception', true)"
        class="ma-2"
      >
        <v-icon left>mdi-login</v-icon>
        {{ $t("commons.return_meeting") }}</v-btn
      >
      <v-btn
        color="primary"
        @click="$emit('goToReception', false)"
        class="ma-2"
      >
        <v-icon left>mdi-home</v-icon>
        {{ $t("commons.back") }}</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "MeetingExit",
  data: function () {
    return {}
  }
}
</script>
